import React from "react";
import Tooltip from "@material-ui/core/Tooltip";

export default function HelpTooltip({ text, children }) {
    return (
        <Tooltip
            title={text}
            arrow
            placement="top"
            enterDelay={200}
        >
            <span
                style={{
                    borderBottom: "1px dashed rgba(192,132,252,0.7)",
                    cursor: "help",
                    color: "#c084fc",
                    transition: "all .2s ease"
                }}
            >
                {children}
            </span>
        </Tooltip>
    );
}